import React, { useContext } from "react";
import { MDBSideNavItem, MDBIcon } from "mdb-react-ui-kit";
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../Context/ThemeContext.js";
import "../../../styles/dark.css";

const NavigationItem = ({ icon, label, link, isActive, click }) => {
  const { theme } = useContext(ThemeContext);
  let themeClass = ( theme === "dark" || theme === "high-contrast") ? "dark" : "";
  return (
    <MDBSideNavItem>
      <Link onClick={click} className={isActive ? `sidenav-link ${themeClass} active` : `sidenav-link ${themeClass}`}>
        <MDBIcon fas icon={icon} className="fa-fw me-3" />
        {label}
      </Link>
    </MDBSideNavItem>
  )
};  


export default NavigationItem;
